import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { id: "platform-admin-login" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, "Painel interno Fluxoo. Acesso restrito à equipe.", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, [
  /*#__PURE__*/_createTextVNode("Digite seu e-mail "),
  /*#__PURE__*/_createElementVNode("strong", null, "*")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "password" }, [
  /*#__PURE__*/_createTextVNode("Digite sua senha "),
  /*#__PURE__*/_createElementVNode("strong", null, "*")
], -1)
const _hoisted_6 = ["type"]
const _hoisted_7 = {
  key: 0,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("g", { id: "vuesax/linear/eye" }, [
  /*#__PURE__*/_createElementVNode("g", { id: "eye" }, [
    /*#__PURE__*/_createElementVNode("path", {
      id: "Vector",
      d: "M15.58 11.9999C15.58 13.9799 13.98 15.5799 12 15.5799C10.02 15.5799 8.41998 13.9799 8.41998 11.9999C8.41998 10.0199 10.02 8.41992 12 8.41992C13.98 8.41992 15.58 10.0199 15.58 11.9999Z",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      id: "Vector_2",
      d: "M12 20.2702C15.53 20.2702 18.82 18.1902 21.11 14.5902C22.01 13.1802 22.01 10.8102 21.11 9.40021C18.82 5.80021 15.53 3.72021 12 3.72021C8.47003 3.72021 5.18003 5.80021 2.89003 9.40021C1.99003 10.8102 1.99003 13.1802 2.89003 14.5902C5.18003 18.1902 8.47003 20.2702 12 20.2702Z",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<path d=\"M14.5299 9.46992L9.46992 14.5299C8.81992 13.8799 8.41992 12.9899 8.41992 11.9999C8.41992 10.0199 10.0199 8.41992 11.9999 8.41992C12.9899 8.41992 13.8799 8.81992 14.5299 9.46992Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M17.8198 5.76998C16.0698 4.44998 14.0698 3.72998 11.9998 3.72998C8.46984 3.72998 5.17984 5.80998 2.88984 9.40998C1.98984 10.82 1.98984 13.19 2.88984 14.6C3.67984 15.84 4.59984 16.91 5.59984 17.77\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M8.41992 19.5299C9.55992 20.0099 10.7699 20.2699 11.9999 20.2699C15.5299 20.2699 18.8199 18.1899 21.1099 14.5899C22.0099 13.1799 22.0099 10.8099 21.1099 9.39993C20.7799 8.87993 20.4199 8.38993 20.0499 7.92993\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M15.5099 12.7C15.2499 14.11 14.0999 15.26 12.6899 15.52\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M9.47 14.53L2 22\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M21.9998 2L14.5298 9.47\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path>", 6)
const _hoisted_17 = [
  _hoisted_11
]
const _hoisted_18 = {
  class: "recaptcha",
  style: {"display":"flex","justify-content":"center","margin":"16px 0 15px 0"}
}
const _hoisted_19 = ["disabled"]

import { ref } from 'vue'
import { isPerformingRequest, useAxios } from '@/api/axios'
import router from '@/router'
import Loader from '@/components/loader/Loader.vue'
import Recaptcha from '@/components/google/Recaptcha.vue'
import { recaptchaConfig } from '@/global/config/recaptcha'
import fluxooLogo from '@/assets/images/fluxoo-doc-logo.png'


export default /*#__PURE__*/_defineComponent({
  __name: 'PlatformAdminLoginView',
  setup(__props) {

const showPassword = ref<boolean>(false)
const loginForm = ref<{email?:string, password?:string, token?: string}>({})
const axios = useAxios()

async function login () {
  axios.post('/api/platform-admin/login', loginForm.value)
    .then(() => {
      router.push({ name: 'platform-admin.dashboard' })
    })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("section", null, [
        _createElementVNode("img", {
          src: _unref(fluxooLogo),
          alt: "Logo fluxoo doc"
        }, null, 8, _hoisted_2),
        _hoisted_3,
        _createElementVNode("form", {
          onSubmit: _cache[3] || (_cache[3] = ($event: any) => ($event.preventDefault())),
          action: ""
        }, [
          _createElementVNode("section", null, [
            _hoisted_4,
            _withDirectives(_createElementVNode("input", {
              autocomplete: "off",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((loginForm.value.email) = $event)),
              type: "text",
              placeholder: "ex: equipe@fluxoo.com.br",
              name: "email",
              id: "email"
            }, null, 512), [
              [_vModelText, loginForm.value.email]
            ])
          ]),
          _createElementVNode("section", null, [
            _hoisted_5,
            _withDirectives(_createElementVNode("input", {
              autocomplete: "off",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((loginForm.value.password) = $event)),
              type: showPassword.value ? 'text':'password',
              placeholder: "ex: 123456",
              name: "password",
              id: "password"
            }, null, 8, _hoisted_6), [
              [_vModelDynamic, loginForm.value.password]
            ]),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (showPassword.value = !showPassword.value))
            }, [
              (showPassword.value)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_9))
                : (_openBlock(), _createElementBlock("svg", _hoisted_10, _hoisted_17))
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(Recaptcha, {
              sitekey: _unref(recaptchaConfig).sitekey,
              callback: (token) => loginForm.value.token = token
            }, null, 8, ["sitekey", "callback"])
          ]),
          _createElementVNode("input", {
            autocomplete: "off",
            disabled: !(loginForm.value.email && loginForm.value.password),
            onClick: login,
            type: "button",
            value: "entrar"
          }, null, 8, _hoisted_19)
        ], 32)
      ])
    ]),
    (_unref(isPerformingRequest))
      ? (_openBlock(), _createBlock(Loader, {
          key: 0,
          zIndex: 99
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})